export type TAnchorPosition = "auto"|"below"|"above"|"left"|"right"|"fixed"
export type TAnchorWidth = "auto"|"match"|"min-match"
export type TAnchorProps = {
    follow?:string
    width?:TAnchorWidth
    anchorPosition?:TAnchorPosition,
    position?:{x:number,y:number}       // anchorposition = fixed
}

export default class AnchorHelepr {
    static anchor(element:HTMLDivElement, target:Element, options:TAnchorProps) {
        const rSelf = element.getBoundingClientRect(), rTarget = target.getBoundingClientRect()

        switch(options.width) {
        case "match":
            if (rSelf.width!=rTarget.width) element.style.setProperty("width", rTarget.width+"px")
            break;
        case "min-match":
            if (rSelf.width<rTarget.width) element.style.setProperty("min-width", rTarget.width+"px")
            break;
        }

        if (options.anchorPosition=="right" || options.anchorPosition=="left") return this.hAnchor(element, rSelf, rTarget)
        else return this.vAnchor(element, rSelf, rTarget)
    }
    static applyStyle(element:HTMLDivElement, styles:Record<string,string>){
        for(const key in styles){
            const val = styles[key], old = element.style.getPropertyValue(key)
            if (old!=val){
                if (val) element.style.setProperty(key, val)
                else element.style.removeProperty(key)
            }
        }
    }
    static vAnchor(element:HTMLDivElement, rSelf:DOMRect, rTarget:DOMRect) {
        var anchor = "vert "
        var top = "unset", bottom = "unset", left = "unset", right = "unset"
        if ( rTarget.bottom + rSelf.height > window.innerHeight && rTarget.top - rSelf.height>0) {
            bottom = "anchor(top)"
            anchor += "above"
        }else{
            top = "anchor(bottom)"
            anchor += "below"            
        }

        if (rTarget.left+rSelf.width+100>=window.innerWidth) {
            right = "anchor(right)"
            anchor += " right"
        }
        else {
            left = "anchor(left)"
            anchor += " left"
        }
        this.applyStyle(element, {left, right, top, bottom})
        return anchor
    }
    static hAnchor(element:HTMLDivElement, rSelf:DOMRect, rTarget:DOMRect) {
        var anchor = "horz "
        var top = "unset", bottom = "unset", left = "unset", right = "unset"
        if (rTarget.right + rSelf.width > window.innerWidth) {
            anchor += "left"
            right = "anchor(left)"
        }else{
            anchor += "right"
            left = "anchor(right)"
        }
        if (rTarget.top+rSelf.height>window.innerHeight) {
            bottom = "anchor(bottom)"
            anchor += "above"
        }
        else {
            top = "anchor(top)"
            anchor += "below"
        }
        this.applyStyle(element, {left, right, top, bottom})
        return anchor
    }
}